module.exports = __webpack_public_path__ + "media/images/pic/certificates/brc-food-78839718d55454743dab13f36df20031.png";